var map = {
	"./Auth/Login": 9025,
	"./Auth/Login.vue": 9025,
	"./Dashboard/DashboardOldPage": 8618,
	"./Dashboard/DashboardOldPage.vue": 8618,
	"./Dashboard/DashboardPage": 6659,
	"./Dashboard/DashboardPage.vue": 6659,
	"./Dashboard/DashboardPairPage": 6,
	"./Dashboard/DashboardPairPage.vue": 6,
	"./Exchanges/ExchangePage": 5945,
	"./Exchanges/ExchangePage.vue": 5945,
	"./Exchanges/ExchangePairPage": 141,
	"./Exchanges/ExchangePairPage.vue": 141,
	"./Grid/GridListPage": 7866,
	"./Grid/GridListPage.vue": 7866,
	"./Grid/GridPairPage": 5204,
	"./Grid/GridPairPage.vue": 5204,
	"./Hll/HllListPage": 7137,
	"./Hll/HllListPage.vue": 7137,
	"./Hll/HllPairPage": 596,
	"./Hll/HllPairPage.vue": 596,
	"./Hll/HllPairStatsPage": 2968,
	"./Hll/HllPairStatsPage.vue": 2968,
	"./Jmc/JmcListPage": 8265,
	"./Jmc/JmcListPage.vue": 8265,
	"./Jmc/JmcPairPage": 7316,
	"./Jmc/JmcPairPage.vue": 7316,
	"./Lorentz/LorentzPage": 6189,
	"./Lorentz/LorentzPage.vue": 6189,
	"./Money/MoneyPage": 5266,
	"./Money/MoneyPage.vue": 5266,
	"./Preview/PreviewGridPage": 2623,
	"./Preview/PreviewGridPage.vue": 2623,
	"./Preview/PreviewHllPage": 8162,
	"./Preview/PreviewHllPage.vue": 8162,
	"./Preview/PreviewJmcPage": 2952,
	"./Preview/PreviewJmcPage.vue": 2952,
	"./Preview/PreviewThllPage": 5049,
	"./Preview/PreviewThllPage.vue": 5049,
	"./Preview/ReplayDataArea": 8508,
	"./Preview/ReplayDataArea.vue": 8508,
	"./Replay/ReplayDataChart": 8824,
	"./Replay/ReplayDataChart.vue": 8824,
	"./Replay/ReplayDataList": 5487,
	"./Replay/ReplayDataList.vue": 5487,
	"./Replay/ReplayDataView": 6738,
	"./Replay/ReplayDataView.vue": 6738,
	"./ReplayResult": 8910,
	"./ReplayResult.vue": 8910,
	"./ReplayResultChartPage": 5562,
	"./ReplayResultChartPage.vue": 5562,
	"./ReplaysList": 7070,
	"./ReplaysList.vue": 7070,
	"./Settings/ExchangeBalances": 3535,
	"./Settings/ExchangeBalances.vue": 3535,
	"./Settings/SettingsPage": 572,
	"./Settings/SettingsPage.vue": 572,
	"./TestIndicators/TestIndicatorHllPage": 3638,
	"./TestIndicators/TestIndicatorHllPage.vue": 3638,
	"./TestIndicators/TestIndicatorLeledcPage": 1974,
	"./TestIndicators/TestIndicatorLeledcPage.vue": 1974,
	"./TestIndicators/TestIndicatorMaPage": 5328,
	"./TestIndicators/TestIndicatorMaPage.vue": 5328,
	"./TestIndicators/TestIndicatorMacPage": 8403,
	"./TestIndicators/TestIndicatorMacPage.vue": 8403,
	"./TestIndicators/TestIndicatorPeakPage": 8888,
	"./TestIndicators/TestIndicatorPeakPage.vue": 8888,
	"./TestIndicators/TestIndicatorRsPage": 1210,
	"./TestIndicators/TestIndicatorRsPage.vue": 1210,
	"./TestIndicators/TestIndicatorsPage": 524,
	"./TestIndicators/TestIndicatorsPage.vue": 524,
	"./Tuning/TuningPage": 8525,
	"./Tuning/TuningPage.vue": 8525
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3218;